import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  const bizType = {
    1: '租赁合同',
    2: '委托划扣协议',
  }
  const contractTemplateState = {
    0: '停用',
    1: '启用',
  }

  const isDefault = {
    0: '否',
    1: '是',
  }
  const tableColumns = [
    {
      name: 'id',
      align: 'center',
      columnProps: {
        label: '合同模板ID',
        prop: 'id',
        minWidth: 120,
      },
    },
    {
      name: 'bizType',
      align: 'center',
      columnProps: {
        label: '合同模板类型',
        prop: 'bizType',
        minWidth: 120,
      },
      render: ({ row }) => {
        return bizType[row.bizType] || '--'
      },
    },
    {
      name: 'name',
      align: 'center',
      columnProps: {
        label: '合同模板名称',
        prop: 'name',
        minWidth: 120,
      },
    },
    {
      name: 'state',
      align: 'center',
      columnProps: {
        label: '合同模版状态',
        prop: 'state',
        minWidth: 120,
      },
      render: ({ row }) => {
        return contractTemplateState[row.state] || '--'
      },
    },
    {
      name: 'gmtCreate',
      align: 'center',
      columnProps: {
        label: '创建日期',
        prop: 'gmtCreate',
        minWidth: 120,
      },
    },
    {
      name: 'gmtModified',
      align: 'center',
      columnProps: {
        label: '最近更新日期',
        prop: 'gmtModified',
        minWidth: 120,
      },
    },
    {
      name: 'isDefault',
      align: 'center',
      columnProps: {
        label: '是否默认模版',
        prop: 'isDefault',
        minWidth: 120,
      },
      render: ({ row }) => {
        return isDefault[row.isDefault] || '--'
      },
    },
  ]

  const searchBoxColumns = [
    {
      type: 'input',
      label: '合同模版名称',
      key: 'name',
      options: {
        clearable: true,
        change_s: this.handleTemplatecheck,
      },
    },
    {
      type: 'select',
      label: '合同模版状态',
      key: 'state',
      source: [{ label: '全部', value: 2 }, { label: '启用', value: 1 }, { label: '停用', value: 0 }],
      options: {
        clearable: true,
      },
    },
  ]

  tableColumns.push(
    {
      name: 'operate',
      align: 'center',
      columnProps: {
        label: '操作',
        width: 240,
        fixed: 'right',
      },
      maxShowLength: operateMaxShowLength,
      render: ({ row }) => {
        const btns = []
        // 默认模板不允许编辑
        if (this.judgePermission('editContractTemplate') && row.isDefault !== 1) {
          btns.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.editContractTemplate(row)
                },
              },
            }, '编辑'),
          )
        }

        if (this.judgePermission('copyContractTemplate')) {
          btns.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.copyContractTemplate(row)
                },
              },
            }, '复制'),
          )
        }

        if (this.judgePermission('entrustWithholdDisabled') && row.state === 1) {
          btns.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.entrustWithholdDisabledOrDisabled(row)
                },
              },
            }, '停用'),
          )
        }

        if (this.judgePermission('entrustWithholdEnable') && row.state === 0) {
          btns.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.entrustWithholdDisabledOrDisabled(row)
                },
              },
            }, '启用'),
          )
        }

        if (this.judgePermission('previewContractTemplate')) {
          btns.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.previewContractTemplate(row)
                },
              },
            }, '预览'),
          )
        }
        return btns
      },
    },
  )
  return {
    tableColumns,
    searchBoxColumns,
  }
}
